import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules  } from '@angular/router'; 
import { PagesComponent } from './pages/pages.component';
import { BlankComponent } from './pages/blank/blank.component';
import { SearchComponent } from './pages/search/search.component';
import { NotFoundComponent } from './pages/errors/not-found/not-found.component';
// import {} from './pages/support-ticket/view-support-ticket/view-support-ticket.module'
import { LoginComponent } from './pages/auth/login/login.component';

export const routes: Routes = [
  {
    path: 'admin',
    loadChildren: () => import('../app/pages/auth/auth.module').then(m => m.AuthModule),
  },
  {
    path: 'home', 
    component: PagesComponent,
    children:[
      { path: 'dashboard', loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule), data: { breadcrumb: 'Dashboard' }  },          
      
      {
        path: 'user',
        loadChildren: () => import('../app/pages/user/view-user/view-user.module').then(m => m.ViewUserModule), data: { breadcrumb: 'Admin User Details' }
      },
 
  {
    path: 'appuser',
    loadChildren: () =>
      import('./pages/app-user/view-app-user/view-app-user.module').then((m) => m.AppUserViewModule), data: { breadcrumb: ' User ' }
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('./pages/auth/profile/profile.module').then((m) => m.ProfileModule), data: { breadcrumb: 'Profile' }
  },
 
  {
    path: 'useradminmaster',
    loadChildren: () =>
      import('./pages/User-Admin-Master/view-user-admin/view-user-admin.Module').then((m) => m.ViewUserAdminModule ), data: { breadcrumb: ' useradminmaster ' }
  },
  {
    path: 'adduseradminmaster',
    loadChildren: () =>
      import('./pages/User-Admin-Master/add-user-admin/add-user-admin.Module').then((m) => m.AddUserAdminModule ), data: { breadcrumb: ' useradminmaster ' }
   },
   {
    path: 'Collection',
    loadChildren: () =>
      import('./pages/Collection_Master/view-collection-master/View-Collection-Master.Module').then((m) => m.ViewCollectionModule ), data: { breadcrumb: ' Collection ' }
  },
  {
    path: 'Collection/add',
    loadChildren: () =>
    import('./pages/Collection_Master/view-collection-master/View-Collection-Master.Module').then((m) => m.ViewCollectionModule ), data: { breadcrumb: ' Collection' }
   },
  
   {
    path: 'usercollection',
    loadChildren: () =>
      import('./pages/User-Collection/view-user-collection/view-user-collection.Module').then((m) => m.ViewUserCollectionModule ), data: { breadcrumb: ' usercollection ' }
  },
  {
    path: 'addusercollection',
    loadChildren: () =>
      import('./pages/User-Collection/add-user-collection/add-user-collection.Module').then((m) => m.AddUserCollectionModule ), data: { breadcrumb: ' usercollection ' }
   },
  
   {
    path: 'userpost',
    loadChildren: () =>
      import('./pages/User-Collection/view-user-post/view-user-post.Module').then((m) => m.ViewUserPostModule ), data: { breadcrumb: ' userpost ' }
  },
 
  {
    path: 'userpostlist',
    loadChildren: () =>
      import('./pages/User-Post/view-user-post/view-user-post.Module').then((m) => m.ViewUserPostModule ), data: { breadcrumb: ' userpostlist ' }
  },
  {
    path: 'adduserpostlist',
    loadChildren: () =>
      import('./pages/User-Post/add-user-post/add-user-post.Module').then((m) => m.AddUserPostModule ), data: { breadcrumb: ' userpostlist ' }
   },
   {
    path: 'Orders',
    loadChildren: () =>
      import('./pages/spotlight-post/view-spotlight-post/view-spotlight-post.Module').then((m) => m.ViewSpotlightPostModule ), data: { breadcrumb: ' Orders ' }
  },
  {
    path: 'addspotlightpostlist',
    loadChildren: () =>
      import('./pages/spotlight-post/add-spotlight-post/add-spotlight-post.Module').then((m) => m.AddSpotlightPostModule ), data: { breadcrumb: ' Orders ' }
   },
  //  {
  //   path: 'Shopper-management',
  //   loadChildren: () =>
  //     import('./pages/tattoo-artist/view-tattoo-artist-list/viewtattoo-artist.module').then((m) => m.viewTattooArtistModule ), data: { breadcrumb: ' Shopper-management ' }
  // },
  // {
  //   path: 'UserShow',
  //   loadChildren: () =>
  //     import('./pages/tattoo-artist/add-tattoo-artist/Addtattoo-artist.module').then((m) => m.AddTattooArtistModule ), data: { breadcrumb: ' User Show ' }
  // },
  {
    path: 'Subscription-management',
    loadChildren: () =>
      import('./pages/tattoo-artist/helep-video-mng/helep-video-mng.module').then((m) => m.HelepVideoMngModule ), data: { breadcrumb: ' Subscription-management ' }
  },
  // {
  //   path: 'Order-management',
  //   loadChildren: () =>
  //     import('./pages/tattoo-artist/brand/brand.module').then((m) => m.BrandModule ), data: { breadcrumb: ' Order-management ' }
  // },
  {
    path: 'appuserNew',
    loadChildren: () =>
      import('./pages/tattoo-artist/add-user-new/add-user-new.module').then((m) => m.AddUserNewModule), data: { breadcrumb: ' User ' }
  },
  {
    path: 'FAQ-management',
    loadChildren: () =>
      import('./pages/tattoo-artist/view-tattoo-artist-list/viewtattoo-artist.module').then((m) => m.viewTattooArtistModule ), data: { breadcrumb: ' FAQ-management ' }
  },
  {
    path: 'Testimonials',
    loadChildren: () =>
      import('./pages/tattoo-artist/view-orders/view-orders.module').then((m) => m.ViewOrdersModule ), data: { breadcrumb: 'Testimonials' }
  },
  { path: 'Employer-Management', loadChildren: () => import('./pages/user-subscription/user-subscription-list/user-subscription-list.module').then(m => m.UserSubscriptoinListModule), data: { breadcrumb: 'Employer-Management' } },
  { path: 'Employer-user', loadChildren: () => import('./pages/user-subscription/create-user-subscription/create-user-subscription.module').then(m => m.UserSubscriptionModule), data: { breadcrumb: 'Employer-user' } },
  { path: 'user-subscription', loadChildren: () => import('./pages/tattoo-artist/brand/brand.module').then(m => m.BrandModule), data: { breadcrumb: 'New User Subscription' } },
  { path: 'TattooArtistAdd', loadChildren: () => import('./pages/tattoo-artist/add-tattoo-artist/Addtattoo-artist.module').then(m => m.AddTattooArtistModule), data: { breadcrumb: 'New TattooArtistAdd' } },
  { path: 'Add-Orders', loadChildren: () => import('./pages/tattoo-artist/add-orders/add-orders.module').then(m => m.AddOrdersModule), data: { breadcrumb: 'Testimonial Info' } },
  {
    path: 'Users',
    loadChildren: () =>
      import('./pages/tattoo-artist/view-users/view-users.module').then((m) => m.ViewUsersModule ), data: { breadcrumb: 'Users' }
  },
  {
    path: 'Usersview',
    loadChildren: () =>
      import('./pages/tattoo-artist/add-users/add-users.module').then((m) => m.AddUsersModule), data: { breadcrumb: ' Usersview ' }
  },
  { path: 'BlockUsers', loadChildren: () => import('./pages/tattoo-artist/page1/page1.module').then(m => m.Page1Module), data: { breadcrumb: 'BlockUsers' } },
  {
    path: 'BlockUserDetails',
    loadChildren: () =>
      import('./pages/tattoo-artist/page2/page2.module').then((m) => m.Page2Module ), data: { breadcrumb: ' BlockUsersView ' }
  },
  /*
  {//import view module after exec
    path: 'groupdetails',
    loadChildren: () =>
      import('./pages/Group-Details/view-Group-Details/view-group-details.module').then((m) => m.viewGroupDetailModule), data: { breadcrumb: 'Getuser-Group-Detais' }
  },*/
  



  /*{


    http://localhost:4200/home/background/addbackgroundProvider/new
    path:'view-background',
    loadChildren:()=>
    import('./pages/background-providers/view-background-provider/view-background-provider.module')

  },*/

      { path: 'search', component: SearchComponent, data: { breadcrumb: 'Search' } }
    
    ]
  },
  
  // { path: '**', component: NotFoundComponent }
   { path: '', redirectTo: '/admin/login', pathMatch: 'full' },
  
]; 

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      // preloadingStrategy: PreloadAllModules, // <- comment this line for activate lazy load
      // relativeLinkResolution: 'IPLAdmin',
      // // useHash: true
    })
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }